module.exports = __webpack_public_path__ + "fonts/comfortaa-regular-webfont.125ea6a7.ttf";